import { IS_AWS_ENV } from "constants/app.constants";
import { createMergeWithDefaults } from "entities/utils";
import { WellStatusCurrentChartRequestType } from "types";

// Lean request for the Current Well Status chart. Same endpoint as the
// over-time chart, discriminated by chartType; no time axis.
//
// `status` is a verbatim `header.status` value, NOT the bare WellStatus
// abbreviation, since the aggregation matches the stored field directly: the
// stage-prefixed form on Azure ("06. PROD"), UDM display text on AWS ("Active").
// Options come from the hardcoded wellStatusCurrentOptions() list. PROD is the
// default because it is the largest and most-asked-for population; Active is its
// AWS counterpart.
//
// A function so IS_AWS_ENV is never read at import. resolveWellStatusSelection
// applies it on every read, so `status` below is only the Azure placeholder.
export const defaultWellStatusCurrentStatus = (): string =>
  IS_AWS_ENV ? "Active" : "06. PROD";

export const DEFAULT_WELL_STATUS_CURRENT_REQUEST: WellStatusCurrentChartRequestType = {
  chartType: "WellStatusCurrent",
  status: "06. PROD",
  allStatuses: false,
  focus: { property: "" },
  filterId: null,
  // Deliberately pinned, unlike the over-time chart's copy of this default
  // (wellStatusOverTime.ts): the Rust current-status path guards its leg logic
  // behind `!include_drain_legs &&`, so leg-ness is never evaluated there. This
  // chart has no drain-legs toggle and none should be added without redoing the
  // count verification for this path (EVA-120 plan §4.4).
  includeDrainLegs: true
};

// See the matching note in wellStatusOverTime.ts: `focus` is assigned after
// createEntityState, never merged as an override.
export const generateWellStatusCurrentRequestBody = createMergeWithDefaults(
  DEFAULT_WELL_STATUS_CURRENT_REQUEST
);
